import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.minimumRows = Number.parseInt(this.element.getAttribute("rows"), 10) || 3
    this.originalOverflowY = this.element.style.overflowY
    this.element.style.overflowY = "hidden"
    this.element.addEventListener("input", this.resize)
    this.resize()
  }

  disconnect() {
    this.element.removeEventListener("input", this.resize)
    this.element.style.overflowY = this.originalOverflowY
  }

  resize = () => {
    if (this.element.offsetParent === null) return

    const styles = window.getComputedStyle(this.element)
    const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.5
    const padding = Number.parseFloat(styles.paddingTop) + Number.parseFloat(styles.paddingBottom)
    const borders = Number.parseFloat(styles.borderTopWidth) + Number.parseFloat(styles.borderBottomWidth)
    const minimumHeight = this.minimumRows * lineHeight + padding + borders

    this.element.style.height = "auto"
    this.element.style.height = `${Math.max(this.element.scrollHeight + borders, minimumHeight)}px`
  }
}
